
















import Vue from "vue";

interface Computed {
  selectedAnswerIndex?: number;
  title: string;
  questionNumber: string;
  totalQuestions: number;
}

interface Methods {
  selectAnswerIndex: (selectedIndex: number) => void;
}

interface Props {
  answer: any;
  canSelect: boolean;
  canReselect: boolean;
  disabled: boolean;
  header: string[];
  options: {}[];
  problemUuid: string;
  selectedOptions: any;
  showAnswer: boolean;
  showRadioIcon: boolean;
  allProblemUuids: string[];
}

export default Vue.extend<{}, Methods, Computed, Props>({
  name: "ListeningMultipleChoice",
  props: {
    answer: {
      type: Object,
      default: undefined
    },
    canReselect: {
      type: Boolean,
      default: true
    },
    canSelect: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    header: {
      type: Array,
      default: () => [""]
    },
    options: {
      type: Array,
      required: true
    },
    problemUuid: {
      type: String,
      required: true
    },
    selectedOptions: {
      type: Object,
      required: true
    },
    showAnswer: {
      type: Boolean,
      default: false
    },
    showRadioIcon: {
      type: Boolean,
      default: true
    },
    allProblemUuids: {
      type: Array,
      required: true
    }
  },
  computed: {
    selectedAnswerIndex() {
      const selectedOption = this.selectedOptions[this.problemUuid];
      return (selectedOption && selectedOption.id) || undefined;
    },
    title() {
      // TODO:: Regex replace is temporary solution to strip "Q#" from titles.
      // When back-end is fixed to no longer return question numbers in the title, this can just return this.header[0].
      return this.header[0]?.replace(/^Q([0-9]+)\s*/, "");
    },
    questionNumber() {
      const index = this.allProblemUuids.indexOf(this.problemUuid);
      return `Q${index + 1}`;
    },
    totalQuestions() {
      return this.allProblemUuids.length;
    }
  },
  methods: {
    selectAnswerIndex(selectedOption: any) {
      this.$emit("select-answer-index", selectedOption, this.problemUuid);
    }
  }
});
